export interface SignupIntent {
  plan: string;
  credits?: number;
  currency?: string;
  source?: string;
  medium?: string;
  campaign?: string;
}

const KEY = 'frameon.signupIntent';
const PLAN = /^[a-z]{2,20}$/;
const TOKEN = /^[A-Za-z0-9_.-]{1,64}$/;

function token(value: string | null) {
  return value && TOKEN.test(value) ? value : undefined;
}

export function captureSignupIntent(url: URL): SignupIntent | null {
  const plan = url.searchParams.get('plan') || '';
  if (!PLAN.test(plan)) return readSignupIntent();
  const credits = Number(url.searchParams.get('credits'));
  const currency = url.searchParams.get('currency') || '';
  const intent: SignupIntent = {
    plan,
    ...(Number.isInteger(credits) && credits > 0 ? { credits } : {}),
    ...(/^[A-Z]{3}$/.test(currency) ? { currency } : {}),
    ...(token(url.searchParams.get('utm_source')) ? { source: token(url.searchParams.get('utm_source')) } : {}),
    ...(token(url.searchParams.get('utm_medium')) ? { medium: token(url.searchParams.get('utm_medium')) } : {}),
    ...(token(url.searchParams.get('utm_campaign')) ? { campaign: token(url.searchParams.get('utm_campaign')) } : {})
  };
  try { sessionStorage.setItem(KEY, JSON.stringify(intent)); } catch { return intent; }
  return intent;
}

export function readSignupIntent(): SignupIntent | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null') as SignupIntent | null;
    return value && PLAN.test(value.plan) ? value : null;
  } catch {
    return null;
  }
}

export function clearSignupIntent() {
  try { sessionStorage.removeItem(KEY); } catch { return; }
}

export function pricingPathFor(intent: SignupIntent) {
  return `/pricing?plan=${encodeURIComponent(intent.plan)}`;
}
